$(document).ready(function () {
  const walletVariantID = 44393187672260; // Wallet variant ID
  const targetProductType = "Perfumes";
  const minPrice = 149900; // ₹1499 in paise

  function updateWalletBasedOnCart(cart) {
    let hasEligiblePerfume = false;
    let walletInCart = false;
    let walletItemKey = null;

    cart.items.forEach(item => {
      if (item.product_type === targetProductType && item.final_price >= minPrice) {
        hasEligiblePerfume = true;
      }
      if (item.variant_id === walletVariantID) {
        walletInCart = true;
        walletItemKey = item.key;
      }
    });

    if (hasEligiblePerfume && !walletInCart) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: walletVariantID, quantity: 1 })
      }).then(() => {
        console.log('✅ Wallet auto-added');
        refreshAndUpdateCart();
      });
    }

    if (!hasEligiblePerfume && walletInCart) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: walletItemKey, quantity: 0 })
      }).then(() => {
        console.log('❌ Wallet auto-removed');
        if (window.location.pathname === '/cart') {
          location.reload();
        } else {
          refreshAndUpdateCart();
        }
      });
    }
  }

  function refreshAndUpdateCart() {
    $.getJSON('/cart.js', function (cart) {
      updateWalletBasedOnCart(cart);
      renderMiniCart(cart);
    });
  }

  function renderMiniCart(cart) {
    const container = $('.mini_cart_items.js_cat_items');
    const subtotalElem = $('.cart_tot_price');
    const emptyMsg = $('.empty');
    const cartFooter = $('.mini_cart_footer');

    if (!container.length) return;

    let html = '';
    let subtotal = 0;

    if (cart.items.length === 0) {
      container.html('');
      emptyMsg.removeClass('dn');
      cartFooter.addClass('dn');
      subtotalElem.text('Rs. 0');
      return;
    }

    emptyMsg.addClass('dn');
    cartFooter.removeClass('dn');

    cart.items.forEach(item => {
      subtotal += item.line_price;

      const showWalletDiscount =
        item.variant_id === walletVariantID &&
        cart.items.some(p => p.product_type === targetProductType && p.final_price >= minPrice);

      html += `
        <div class="mini_cart_item js_cart_item cart_item_${item.variant_id} flex al_center pr oh">
          <div class="ld_cart_bar"></div>
          <a href="${item.url}" class="mini_cart_img">
            <img src="${item.image}" alt="${item.product_title}" />
          </a>
          <div class="mini_cart_info">
            <a href="${item.url}" class="mini_cart_title truncate">${item.product_title}</a>
            <div class="mini_cart_meta">
              <p class="cart_meta_variant">${item.variant_title || ''}</p>
              <div class="cart_meta_price price">
                <div class="cart_price">Rs. ${(item.final_line_price / 100).toLocaleString()}</div>
                ${showWalletDiscount ? `
                  <ul class="cart_discount_price ul_none">
                    <li class="order-discount__item">
                      <i class="facl facl-tags"></i> Buy Perfume 1499, Get Wallet Free (-Rs. 599)
                    </li>
                  </ul>` : ''}
              </div>
            </div>
            <div class="mini_cart_actions">
              <div class="quantity pr mr__10 qty__true">
                <input type="number" class="input-text qty text tc qty_cart_js" data-id="${item.key}" value="${item.quantity}" min="0" />
                <div class="qty tc fs__14">
                  <button type="button" class="plus db cb pa pd__0 pr__15 tr r__0">+</button>
                  <button type="button" class="minus db cb pa pd__0 pl__15 tl l__0">-</button>
                </div>
              </div>
              <a href="${item.url}" class="cart_ac_edit js__qs ttip_nt tooltip_top_right" data-id="${item.key}">Edit</a>
              <a href="#" class="cart_ac_remove js_cart_rem ttip_nt tooltip_top_right" data-id="${item.key}">Remove</a>
            </div>
          </div>
        </div>
      `;
    });

    container.html(html);
    subtotalElem.text(`Rs. ${(subtotal / 100).toLocaleString()}`);
  }

  function changeItemQuantity(itemKey, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: quantity })
    }).then(() => refreshAndUpdateCart());
  }

  // ✅ Quantity input manual change
  $(document).on('change', 'input.qty_cart_js', function () {
    const itemKey = $(this).data('id');
    const qty = parseInt($(this).val(), 10);
    if (!isNaN(qty) && qty >= 0) {
      changeItemQuantity(itemKey, qty);
    }
  });

  // ✅ Quantity plus button
  $(document).on('click', '.quantity .plus', function () {
    const input = $(this).closest('.quantity').find('.qty_cart_js');
    let qty = parseInt(input.val(), 10) || 0;
    qty += 1;
    input.val(qty);
    changeItemQuantity(input.data('id'), qty);
  });

  // ✅ Quantity minus button
  $(document).on('click', '.quantity .minus', function () {
    const input = $(this).closest('.quantity').find('.qty_cart_js');
    let qty = parseInt(input.val(), 10) || 0;
    if (qty > 0) {
      qty -= 1;
      input.val(qty);
      changeItemQuantity(input.data('id'), qty);
    }
  });

  // ✅ Remove item
  $(document).on('click', '.cart_ac_remove', function (e) {
    e.preventDefault();
    const itemKey = $(this).data('id');
    changeItemQuantity(itemKey, 0);
  });

  // ✅ Re-render after Add to Cart
  $(document).on('click', '.single_add_to_cart_button:not(.disabled)', function () {
    setTimeout(refreshAndUpdateCart, 600);
  });

  // ✅ Initial cart load
  refreshAndUpdateCart();
});
